import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '@marvelapp/marvel-ui/button';
import MarvelLink from '@marvelapp/marvel-ui/link';
import Google from 'marketing-website/components/icons/Google';

import styles from './style/general.module.css';

export default class GoogleButton extends Component {
  state = {
    isPending: false,
  };

  render() {
    const {
      minWidth,
      children,
      redirectTo,
      block,
      shape,
      siteMaintenance,
    } = this.props;
    const icon = (
      <div style={{ marginLeft: children ? 10 : 0 }}>
        <Google size={26} display="block" />
      </div>
    );
    const url = siteMaintenance
      ? '/signup'
      : `/auth/drive_auth_start/?next=${encodeURIComponent(redirectTo)}`;
    return (
      <div className={styles.googleButton}>
        <MarvelLink block={block} url={url}>
          <Button
            fullWidth={!minWidth}
            hover="google"
            icon={icon}
            iconColor="google"
            isLoading={this.state.isPending}
            kind="ghost"
            minWidth={minWidth}
            shape={shape}
            size="large"
          >
            {children}
          </Button>
        </MarvelLink>
      </div>
    );
  }
}

GoogleButton.defaultProps = {
  siteMaintenance: false,
};

GoogleButton.propTypes = {
  block: PropTypes.bool,
  children: PropTypes.string,
  siteMaintenance: PropTypes.bool,
  minWidth: PropTypes.number,
  redirectTo: PropTypes.func.isRequired,
  shape: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/modules/FormWrap/GoogleButton/index.js